(function(angular){
	'use strict';
	
	angular.module('agreementsModule', [
		'coreModule',
		'formValidationModule'
	]);

})(window.angular);